import React from 'react';
import { stats } from '../../content/siteContent';

export default function StatsBar() {
  return (
    <section className="stats-bar" aria-label="Estatísticas da Empresa">
      <span id="logoCollection" className="anchor-alias" aria-hidden="true" />
      <div className="stats-container">
        {stats.map((stat) => (
          <div className="stat-item" key={stat.label}>
            <div className="stat-value">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
